import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--edit-first-appointment-modal',
    ];

    static targets = [
        'option',
        'otherOptionDescription',
        'firstConsultationPrice',
        'firstConsultationFreeIfCaseOpenedPrice',
    ];

    connect() {
        this.optionTargets.forEach(option => {
            if (option.checked) {
                if (option.value === 'other') {
                    this.otherOptionDescriptionTarget.style.display = 'block';
                }
                if (option.value === 'paid') {
                    this.firstConsultationPriceTarget.style.display = 'block';
                }
                if (option.value === 'free-when-case-opened') {
                    this.firstConsultationFreeIfCaseOpenedPriceTarget.style.display = 'block';
                }
            }
        });
    }

    openModal(event) {
        event.preventDefault();

        this.profileEditFirstAppointmentModalOutlet.openModal();
    }
}
